import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  loadMore: {
    id: 'app.containers.Chatbot.loadMore',
    defaultMessage: `Load More`,
  },
});
